(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-warranty-label"] && !Shopify.designMode) return;
  try {
    (() => {
      if (window.cartWarrantyLabelBound) return;
      window.cartWarrantyLabelBound = true;

      let suppressDrawerEscape = false;

      document.addEventListener('click', (event) => {
        const opener = event.target.closest('.cart-warranty-label__button');

        if (opener) {
          const key = opener.dataset.warrantyDialog;
          const matches = [...document.querySelectorAll(`dialog[data-warranty-dialog="${key}"]`)];
          const fresh = matches.find((node) => node.parentElement !== document.body);
          const dialog = fresh || matches[0];

          matches.forEach((node) => {
            if (node !== dialog) node.remove();
          });

          if (!dialog) return;

          if (dialog.parentElement !== document.body) document.body.appendChild(dialog);
          if (!dialog.open) dialog.showModal();
          return;
        }

        const closer = event.target.closest('.cart-warranty-label__close');

        if (closer) {
          closer.closest('dialog')?.close();
          return;
        }

        if (event.target.matches('dialog.cart-warranty-label__dialog')) event.target.close();
      });

      document.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Escape') return;

          const dialog = event.target.closest('dialog.cart-warranty-label__dialog');

          if (!dialog || !dialog.open) return;

          suppressDrawerEscape = true;
          event.stopPropagation();
        },
        true
      );

      document.addEventListener(
        'keyup',
        (event) => {
          if (event.key !== 'Escape' || !suppressDrawerEscape) return;

          suppressDrawerEscape = false;
          event.stopPropagation();
        },
        true
      );

      const mountUpcartWarrantyLabel = () => {
        const source = document.querySelector('cart-drawer .cart-warranty-label');
        const popup = document.getElementById('CartPopup') || document.getElementById('upCart');

        if (!source || !popup) return;

        const hasItems = popup.querySelector('.upcart-product-item, .upcart-public-cart-item');
        const existing = popup.querySelector('[data-warranty-upcart]');

        if (!hasItems) {
          existing?.remove();
          return;
        }

        const slot = popup.querySelector('.cart-warranty-label-slot');

        if (slot) {
          if (slot.querySelector('[data-warranty-upcart]')) return;

          existing?.remove();
          const clone = source.cloneNode(true);
          clone.dataset.warrantyUpcart = 'true';
          slot.replaceChildren(clone);
          return;
        }

        const checkout = popup.querySelector('.upcart-checkout-button-container, .upcart-public-cart-summary');
        const footer = popup.querySelector('.upcart-footer');
        const checkoutBlock = checkout?.closest('[class*="checkoutButton"]') || checkout;

        if (existing) return;
        if (!checkoutBlock && !footer) return;

        const clone = source.cloneNode(true);
        clone.dataset.warrantyUpcart = 'true';

        if (checkoutBlock) {
          checkoutBlock.before(clone);
          return;
        }

        footer.prepend(clone);
      };

      const mountWhenReady = () => {
        let attempts = 0;

        const retry = () => {
          mountUpcartWarrantyLabel();
          attempts += 1;

          if (attempts < 10) window.setTimeout(retry, 400);
        };

        retry();
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', mountWhenReady);
      } else {
        mountWhenReady();
      }

      const subscribe = () => {
        if (typeof window.upcartSubscribeCartLoaded !== 'function') return false;

        window.upcartSubscribeCartLoaded(mountUpcartWarrantyLabel);
        return true;
      };

      if (!subscribe()) {
        let subscribeAttempts = 0;
        const waitForSubscribe = () => {
          subscribeAttempts += 1;

          if (subscribe() || subscribeAttempts >= 10) return;

          window.setTimeout(waitForSubscribe, 400);
        };

        waitForSubscribe();
      }
    })();
  } catch(e) { console.error(e); }
})();

})();
